import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { equalValueValidator } from "@tecommon/ui/components/validateEqual/equal-value-validator";
import { LocalStorage } from '@tecommon/ui/components/localStorage/localStorage.service';
import { UserInfo, StandardApiError} from '@tecommon/structures/structures';
import { Globals } from '../../../@tecommon/ui/components/global/globals';
import { SessionCheck } from '../../services/sessionCheck/sessionCheck.service';
import { UserDetail, PasswordValidationResponse, PasswordValidationMessage, PasswordValidationDisplayMessage } from '../../../@tecommon/structures/src/selfServicePortalClasses';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'password-reset',
    templateUrl: './passwordResetPin.component.html',
    standalone: false
})
/** passwordReset component*/
export class PasswordResetPINComponent implements OnInit {
    
    isMDEInstalled: boolean = false;
    callbackNumber: string;
    eventEditForm: FormGroup;
    resetPwdForm: FormGroup;
    callBackPhoneNumberFrmCtl: FormControl;
    @Input()
    isPasswordResetPIN: boolean = false;
    @Input()
    isModal: boolean = false;
    @Input()
    userInfo: UserInfo;
    private _prevSelected: any;
    errorKey: string = "";
    @Output()
    pwdResetByPIN: EventEmitter<void> = new EventEmitter<void>();
    isPasswordSuccess: boolean = false;
    isPasswordResetFailure: boolean = false;
    localStorage: LocalStorage;
    firstName: string;
    lastName: string;
    displayName: string;
    userId: string;
    public isPasswordValid: boolean = false;
    public passwordComplexityScore: number = 0;
    public passwordValidationErrors: PasswordValidationDisplayMessage[];
    public passwordValidationApiException: boolean;
    public word: string;
    isAppIdUser: boolean = false;
    isNeedsPasswordReset: boolean = false;
    isExternalUser: boolean = false;
    public isHideTryAgainOption: boolean = false;
    passwordValidationResponse: PasswordValidationResponse;
    /** passwordReset ctor */
    constructor(private http: HttpClient, private router: Router, private translate: TranslateService, private fb: FormBuilder,
        private readonly localstorage: LocalStorage,
        private globals: Globals,
        private readonly sessionCheck: SessionCheck) {
        this.re.ManagedByTE = "";
        this.re.LocatedInTE = "";
        this.re.LocatedInVPNTE = "";
        this.re.HidePwd = true;
        this.re.HideConfirmPwd = true;
        this.sn.CallBackPhoneNumber = "";
        this._translateService = translate;
        this.localStorage = localstorage;
        this.passwordValidationResponse = new PasswordValidationResponse();
        this.passwordValidationApiException = false;

        //back button disable [started]
        history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', function (event) {
            history.pushState(null, null, window.location.href);
        }); // back button disable [ended]

        this.ClearCookieWhenCloseWindowOrTab();
        this.SessionTimeOutCheck();
    }


    handleChange(evt) {
        var val: String = evt.value;
        if (val === "N") {
            this.re.LocatedInTE = "";
            this.re.LocatedInVPNTE = "";
            this.re.HidePwd = true;
            this.re.HideConfirmPwd = true;
            this.re.Password = "";
            this.re.ConfirmPassword = "";
        }
    }

    handleVPNChange(evt) {
        var val: String = evt.value;
        if (val === "N") {
            this.re.LocatedInVPNTE = "";
            this.re.HidePwd = true;
            this.re.HideConfirmPwd = true;
            this.re.Password = "";
            this.re.ConfirmPassword = "";
        }
    }

    public ngOnInit() {
      this.getRouteData();
    }

    getRouteData() {
        this.loadingControls = true;
        if (this.userInfo != null && this.userInfo != undefined) {
            //for reset pwd validation
            this.firstName = this.userInfo.firstName;
            this.lastName = this.userInfo.lastName;
            this.displayName = this.userInfo.displayName;
            this.userId = this.userInfo.userId;
            this.isNeedsPasswordReset = this.userInfo.needsPasswordReset;
            //this.loadingControls = false;

        } else {
            setTimeout(() => {
                this.http.get<UserInfo>("/api/Login/UserNameInfo").subscribe(result => {
                    this.userInfo = result;
                    console.log('resetpwd-linkclick');
                    this.firstName = this.userInfo.firstName;
                    this.lastName = this.userInfo.lastName;
                    this.displayName = this.userInfo.displayName;
                    this.userId = this.userInfo.userId;
                    this.resetPwdForm = this.fb.group({
                        'ChangePwd': ['', [
                            Validators.required,
                            //Validators.minLength(8),
                            //Validators.pattern(
                            //    /^(?:(?=.*[a-z])(?:(?=.*\W)(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,]))).{8,}$/)
                        ]
                        ], updateOn: 'blur',
                        'ConfirmPwd': ['', [
                            Validators.required,
                            //Validators.minLength(8),
                            //Validators.pattern(
                            //    /^(?:(?=.*[a-z])(?:(?=.*\W)(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,]))).{8,}$/)
                        ]
                        ]
                    },
                        { validator: equalValueValidator('ChangePwd', 'ConfirmPwd', this.displayName, this.userId) }
                        // key is to validate on the form group
                    );
                    //this.loadingControls = false;

                    this.resetPwdForm
                        .get("ChangePwd")
                        .valueChanges.pipe(
                            debounceTime(400),
                            distinctUntilChanged(),
                            switchMap(() => {
                                this.isPasswordValid = false;
                                this.passwordValidationErrors = null;
                                this.passwordComplexityScore = 0;
                                if (this.userInfo && (this.re.Password != '' && this.re.Password != undefined)) {
                                    console.log('calling User controller from password reset component');
                                    var userDetail = new UserDetail();
                                    userDetail.firstName = this.userInfo.firstName.replace('*', '');
                                    userDetail.lastName = this.userInfo.lastName.replace('*', '');
                                    userDetail.password = this.re.Password;
                                    userDetail.userId = this.userInfo.userId;
                                    userDetail.userType = 'network'
                                    //console.log('this is userDetail being sent to BE', userDetail);
                                    return this.http.post("/api/Login/ValidatePassword", userDetail)
                                }
                                return of();
                            })
                        )
                        .subscribe(
                            (result) => {
                                if (result) {
                                    //console.log('API result', result);
                                    //var response = result as PasswordValidationResponse;
                                    //if (response.errors.length > 0) {
                                    //    response.errors.forEach(x => {
                                    //        if (x.errorKey.toLowerCase() == 'dictionaryworderror') {
                                    //            this.word = x.errorValue.split(' ').pop();
                                    //        }
                                    //        //else if (x.messageKey.toLowerCase() == 'internalservererror' || x.messageKey.toLowerCase() == 'invalidusertype' || x.messageKey.toLowerCase() == 'invalidinput') {

                                    //        //    this.showErrorMessage("ResetPasswordFailure");
                                    //        //    this.passwordValidationApiException = true;
                                    //        //}
                                    //    });
                                    //}
                                    if (!this.passwordValidationApiException) {
                                        this.passwordValidationResponse = result as PasswordValidationResponse;
                                        if (this.passwordValidationResponse.isError == true) {
                                            if (this.passwordValidationResponse.errors != null && this.passwordValidationResponse.errors?.length > 0) {
                                                this.passwordValidationErrors = new Array(0);
                                                this.passwordValidationResponse.errors.forEach(x => {
                                                    if (x.errorKey.toLowerCase() == 'dictionaryworderror') {
                                                        const word = x.errorValue.split(' ').pop();
                                                        const passwordValidationDisplayMessage = new PasswordValidationDisplayMessage();
                                                        passwordValidationDisplayMessage.error = x.errorKey;
                                                        passwordValidationDisplayMessage.word = word;
                                                        this.passwordValidationErrors.push(passwordValidationDisplayMessage);
                                                    }
                                                    else {
                                                        const passwordValidationDisplayMessage = new PasswordValidationDisplayMessage();
                                                        passwordValidationDisplayMessage.error = x.errorKey;
                                                        passwordValidationDisplayMessage.word = null;
                                                        this.passwordValidationErrors.push(passwordValidationDisplayMessage);
                                                    }
                                                });
                                            }
                                            //this.passwordValidationErrors = this.passwordValidationResponse.errors;
                                            //console.log(this.passwordValidationErrors);
                                        }
                                        else {
                                            this.isPasswordValid = true;
                                        }
                                    }

                                }
                            },
                            (error) => {
                                //debugger;
                                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                                    this.showErrorMessage("LoginExpired");
                                } else {
                                    this.showErrorMessage("ResetPasswordFailure");
                                    this.passwordValidationApiException = true;
                                }


                            }
                        );

                },
                    error => {
                        this.loadingControls = false;
                        if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                            this.errorMessage = "LoginExpired";
                        } else {
                            this.errorMessage = "FatalErrorMsg";
                        }
                        console.log(error.error.message);
                    });
            });
        }

        this.eventEditForm = new FormGroup({
            'ManagedByTE': new FormControl(),
            'LocatedInTE': new FormControl(),
            'LocatedInVPNTE': new FormControl(),
            'callBackPhoneNumberFrmCtl': new FormControl('', [Validators.required])
        });

        this.resetPwdForm = this.fb.group({
            'ChangePwd': ['', [
                Validators.required,
                //Validators.minLength(8),
                //Validators.pattern(
                //    /^(?:(?=.*[a-z])(?:(?=.*\W)(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,]))).{8,}$/)

            ]
            ], updateOn: 'blur',
            'ConfirmPwd': ['', [
                Validators.required,
                //Validators.minLength(8),
                //Validators.pattern(
                //    /^(?:(?=.*[a-z])(?:(?=.*\W)(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,]))).{8,}$/)
            ]
            ]
        },
            { validator: equalValueValidator('ChangePwd', 'ConfirmPwd', this.displayName, this.userId) }
            // key is to validate on the form group
        );

        this.callBackPhoneNumberFrmCtl = new FormControl('', [Validators.required]);
        this.re.ManagedByTE = "";
        this.re.LocatedInTE = "";
        this.re.LocatedInVPNTE = "";
        this.re.HidePwd = true;
        this.re.HideConfirmPwd = true;
        this.sn.CallBackPhoneNumber = "";
        this.sn.IsMDEInstalled = "false";
        //this.loadingControls = true;
        
        this.http.post<boolean>("/api/Login/IsMDEInstalled", null).subscribe(result => {
                this.isMDEInstalled = result;
                if (this.isMDEInstalled) {
                    this.sn.IsMDEInstalled = "true";
                    //this.loadingControls = false;  // TBD, loadingControls is already FALSE, think it shouldn't be made false at above lines #83 & #112 ??
                }
                else {
                    //this.loadingControls = false; // TBD, loadingControls is already FALSE, think it shouldn't be made false at above lines #83 & #112 ??
                    this.sn.IsMDEInstalled = "false";
                  }
            },
            error => {
                this.loadingControls = false; 
                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.showErrorMessage("LoginExpired");
                } else {
                    if (error.json().name === "GENERIC-ERROR") {
                        this.showErrorMessage("FatalErrorMsg");
                    }
                }
                console.log(error.error.message);
            });

        this.http.post<boolean>("/api/Login/IsAppIDUser", null).subscribe(result => {
            this.isAppIdUser = result;
            if (this.isAppIdUser) {
                this.sn.IsAppIDUser = "true";
            }
            else {
                this.sn.IsAppIDUser = "false";
            }
            this.loadingControls = false;
        },
            error => {
               
                console.log(error.error.message);
                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.showErrorMessage("LoginExpired");
                } else {
                    if (error.json().name === "GENERIC-ERROR") {
                        this.showErrorMessage("FatalErrorMsg");
                    }
                }
                this.loadingControls = false;
            }
        );
        
        }  

    get ChangePwd() {
        return this.resetPwdForm.get('ChangePwd');
    }

    get ConfirmPwd() {
        return this.resetPwdForm.get('ConfirmPwd');
    }
    public re: ResetPassword = new ResetPassword();
    public sn: SnowRequest = new SnowRequest();
    public fontSize: string;
    public message: string;
    public password: string;
    public sqId: number;
    public questions: any[];
    public _translateService: TranslateService;
    public successMessageValue: string;
    public loadingControls: boolean = true;


    public clearResetPassword(): void {
        this.errorKey = null;
        this.successMessageKey = null;
        this.successMessageValue = null;
        this.re.LocatedInTE = "";
        this.re.LocatedInVPNTE = "";
        this.re.ManagedByTE = "";
        this.re.Password = "";
        this.re.ConfirmPassword = "";
       
    }

    public ClearCallbackNumber(): void {
        this.callbackNumber = "";
        this.sn.CallBackPhoneNumber = "";
        this.errorKey = "";
        this.errorMessage = "";
        this.isPasswordResetFailure = false;
        this.isPasswordSuccess = false;
        this.re.Password = "";
        this.re.ConfirmPassword = "";
    }
    public isSubmitDisabled(): boolean {
        if (!(this.re.ManagedByTE === 'Y' && this.re.LocatedInTE === 'N')) {
            if (this.re.ManagedByTE == undefined) {
                return true;
            }
            if (this.re.ManagedByTE === "Y" || (this.re.ManagedByTE === "N" && this.re.LocatedInTE === "Y")) {
                if (this.re.Password === undefined || this.re.ConfirmPassword === undefined) {
                    return true;
                }
                return (this.re.Password !== this.re.ConfirmPassword) &&
                    (this.re.Password !== undefined && this.re.Password !== "");
            } 
        }
        return this.processingRecords;
    }

    public submitResetPassword(): void {
        this.sn.Culture = this._translateService.currentLang;

        if (this.resetPwdForm.status === "INVALID") {
            if (this.resetPwdForm.controls.ChangePwd.status === "INVALID") {
                return;
            }
            if (this.resetPwdForm.controls.ConfirmPwd.status === "INVALID") {
                return;
            }
            return;
        }
        if (this.resetPwdForm.controls.ChangePwd.value !== this.resetPwdForm.controls.ConfirmPwd.value) {
            return;
        }
        //if (this.processingRecords) return; // Don't allow another login attempt while one is already happening.
        this.processingRecords = true;
        this.isHideTryAgainOption = false;

        this.http.post<StandardApiError>("/api/Login/PinPasswordReset", this.re).subscribe(result => {

                console.log(result);
                var error = result;

            if (error != undefined && error.message != undefined) {
                console.log(error.userAccessType);
                if (error.userAccessType === "EXTERNAL") {
                    this.isExternalUser = true;
                }
                switch (error.message) {
                    case 'USER_INFO': // User Info ( FirstName etc), User Data ( User Id ),//Pattern Missmatch
                        this.processingRecords = false;
                        if (error.userAccessType === "INTERNAL") {
                            this.showErrorMessage("PASSWORD_NAMING_COMPLEXITY_I");
                        } else if (error.userAccessType === "EXTERNAL") {
                            this.showErrorMessage("ResetPasswordComplexity");
                        }
                        this.isPasswordResetFailure = true;
                        break;
                    case 'USER_DATA': //User Data ( User Id)
                        this.processingRecords = false;
                        if (error.userAccessType === "INTERNAL") {
                            this.showErrorMessage("PASSWORD_NAMING_COMPLEXITY_I");
                        } else if (error.userAccessType === "EXTERNAL") {
                            this.showErrorMessage("ResetPasswordComplexity");
                        }
                        this.isPasswordResetFailure = true;
                        break;
                    case 'PATTERN_MISS_MATCH': //Pattern Missmatch
                        this.processingRecords = false;
                        if (error.userAccessType === "INTERNAL") {
                            this.showErrorMessage("PASSWORD_NAMING_COMPLEXITY_I");
                        } else if (error.userAccessType === "EXTERNAL") {
                            this.showErrorMessage("ResetPasswordComplexity");
                        }
                        this.isPasswordResetFailure = true;
                        break;
                    case 'NOT_EQUAL': // Not Equal
                        this.processingRecords = false;
                        this.showErrorMessage("PwdNotMatching");
                        this.isPasswordResetFailure = true;
                        break;
                    case 'PASSWORD_MINIMUM_AGE': // Password Minimum Age 7 days
                        this.processingRecords = false;
                        this.showErrorMessage("PasswordMinAge");
                        this.isHideTryAgainOption = true;
                        this.isPasswordResetFailure = true;
                        break;
                    case 'HISTORY_ERROR': // Password Minimum Age 7 days
                        this.processingRecords = false;
                        if (error.userAccessType === "EXTERNAL") {
                            this.showErrorMessage("PasswordResetHistoryFailureTryAgain");
                        }
                        else {
                            this.showErrorMessage("PasswordHistoryError");
                        }
                        this.isHideTryAgainOption = true;
                        this.isPasswordResetFailure = true;
                        break;
                    case 'FATAL_ERROR': //Fatal Error Message 
                        this.processingRecords = false;
                        this.showErrorMessage("PasswordResetHistoryFailureTryAgain");//ResetPasswordFailureOnTryAgain
                        this.isPasswordResetFailure = true;
                        break;
                    default:
                        this.processingRecords = false;
                        if (error.userAccessType === "INTERNAL") {
                            this.showErrorMessage("PasswordResetFailed");
                        } else {
                            this.showErrorMessage("ResetPasswordFailure");//External user
                        }
                        this.isPasswordResetFailure = true;
                        this.isHideTryAgainOption = true;
                        break;
                }

            } else {

                this.processingRecords = false;
                this.isPasswordSuccess = true;
                this.isPasswordResetFailure = false;
                this.showSuccessMessage("PInSuccessMsg");
            }
            },
            error => {
                console.log(error.error.message);
                this.processingRecords = false;
                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.showErrorMessage("LoginExpired");
                } else {
                    if (error.error.userAccessType === "INTERNAL") {
                        this.showErrorMessage("PasswordResetFailed");
                    } else {
                        this.showErrorMessage("ResetPasswordFailure");//External user
                    }
                }
                this.isHideTryAgainOption = true;
                this.isPasswordResetFailure = true;
            }
        );
    }

    public TryAgainResetPassword(): void {
        this.ClearCallbackNumber();
        this.getRouteData();
    }

    public CreateSnowIncident(): void
    {
        this.processingRecords = true;
        this.isHideTryAgainOption = true;
        this.errorKey = "";
        this.errorMessage = "";
        this.isSnowIncidentSubmitted = false;
        this.sn.Culture = this._translateService.currentLang;
        this.http.post<StandardApiError>("/api/Login/SnowIncident", this.sn).subscribe(result => {
            var _result = result;
            if (_result != undefined && _result.name === "Success") {
                this.successMessageKey = null;
                this.successMessageValue = _result.message;
                this.processingRecords = false;
                this.isSnowIncidentSubmitted = true;
                this.isPasswordSuccess = false;
                this.isPasswordResetFailure = false;
            }

        },
            error => {
                console.log(error.error);
                this.processingRecords = false;
                if (error.error.status === 0 || error.error.status === 302 || error.error.message === undefined) {
                    this.showErrorMessage("LoginExpired");
                } else {
                    this.showErrorMessage("UserInEPOResultFailure");
                }
            });
    }

    public errorMessage: any;
    public successMessageKey: any;
    public isSaved: boolean = false;
    public processingRecords: boolean = false;

    public showSuccessMessage(message: string): void {
        this.errorMessage = null;
        this.successMessageKey = message;
        this.isSaved = true;
        this.processingRecords = false;
    }

    public showErrorMessage(message: string): void {
        this.errorKey = message;
        this.errorMessage = message;
        this.successMessageKey = null;
        this.isSaved = false;
        this.processingRecords = false;
    }
    isSnowIncidentSubmitted: boolean = false;


    public ClearCookieWhenCloseWindowOrTab(): void {

        window.onbeforeunload = function (e) {
            console.log('when, window / tab got closed')
            const date = new Date();
            const cookieName = 'myID.PeanutButterChocolateChip';
            let cookieValue = '';
            const nameEQ = encodeURIComponent(cookieName) + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca?.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c?.length);
                if (c.indexOf(nameEQ) === 0) {
                    cookieValue = c.substring(nameEQ?.length, c?.length);  //decodeURIComponent(
                }
            }
            document.cookie = `${cookieName}=${cookieValue}; Path=/; Expires=${date.toUTCString()}`;
            //end clear all the cookies values
            return 'confirmation text to window / tab .';
        };
    }

    public SessionTimeOutCheck(): void {

        this.sessionCheck.watch(); // Our idle session watch service.
    }
}

class ResetPassword {
    public ManagedByTE: string;
    public LocatedInTE: string;
    public LocatedInVPNTE: string;
    public HidePwd: boolean;
    public HideConfirmPwd: boolean;
    public Password: string;
    public ConfirmPassword: string;
    public IsMDEInstalled: string;
    public IsModal: boolean;
    public IsPasswordResetPIN: boolean;
    public IsPasswordSuccess: boolean;
    public IsPasswordResetFailure: boolean;
}

class SnowRequest {
    public CallBackPhoneNumber: string;
    public Culture: string;
    public IsMDEInstalled: string;
    public IsAppIDUser: string;
}
